import { LoadingButton } from "@mui/lab";
import { useFormState } from "react-hook-form";
import { type SxProps } from "@mui/material";

/**
 * Replacement for the react-admin `SaveButton`.
 */
export function SaveButton2(props: {
  /** The default label is "Speichern". */
  label?: string;
  sx?: SxProps;
  disabled?: boolean;
}) {
  const { label = "Speichern", sx, disabled = false } = props;
  const { isValidating, isSubmitting } = useFormState();
  return (
    <LoadingButton type="submit" variant="contained" loading={isValidating || isSubmitting} sx={sx} disabled={disabled}>
      {label}
    </LoadingButton>
  );
}
